import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=dffba2de"
import script from "../../controllers/teacher/teacher-profile.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher/teacher-profile.js?vue&type=script&lang=js&external"
import style0 from "./TeacherProfile.vue?vue&type=style&index=0&id=dffba2de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports